
import React, { useState,useRef, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Container,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
  Button,
  Box,
  Card,
  CardContent,
  Grid
} from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'; // Icon for the button
import Autocomplete from '../modal/AutoComplete';
import PhoneNumberField from '../modal/PhoneNumberField'
import DecimalInput from '../modal/DecimalInput';
import AmountInput from '../modal/AmountInput';
import '../CSS/styles.css'
import {pdfDownload} from '../loginPageService'
import { useAlert } from '../Alert/Alert';

import Modal from '../modal/modal';
import { Margin } from '@mui/icons-material';
import PdfDownloadComponent from './BillGenerationComponent';
function BillGeneration(){

  const pdfDownloadRef = useRef();

    const [customerName, setCustomerName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [pickupLocation, setPickupLocation] = useState('');
    const [carModal, setCarModal] = useState({title:'',year:''});
    
    // Single and Round trip specific fields
    const [dropLocation, setDropLocation] = useState('');
    const [pickupDateTime, setPickupDateTime] = useState('');
    
    // Round trip specific fields
    const [returnDateTime, setReturnDateTime] = useState('');
  
    // Tour-specific fields
    const [tourDestination, setTourDestination] = useState('');
    const [numberOfDays, setNumberOfDays] = useState(0);
    const [rentPerKM, setRentPerKM] = useState('');
    const [totalKM, setTotalKM] = useState(0);
    const [driverFee, setDriverFee] = useState(''); 
     const [driverName, setDriverName] = useState('');
     const [tollCharge, setTollCharge] = useState('');
     const [receivedAmount, setReceivedAmount] = useState(0);
     const [openingKM, setOpeningKM] = useState(0);
     const [closingKM, setClosingKM] = useState(0);
     const [extraCharge , setExtraCharge] = useState(0.0);
     const [rentPerDay , setRentPerDay] = useState(0.0);
     const [modeOfPayment , setModeOfPayment] = useState('');
     const [disableButton , setDisableButton] = useState(false);

     const navigate = useNavigate();

     const {showAlert , setToken , authToken} = useAlert();

     const [generateBill,setGenerateBill] = useState(false);

     const [form,setForm] = useState({});


     useEffect(()=>{

      console.log(localStorage.getItem("authToken"),"token");

      if(localStorage.getItem("authToken")==''){
        navigate('/login');
      }

     },[])


     useEffect(()=>{

           setTotalKM(closingKM-openingKM)
      

     },[openingKM,closingKM])


    const handlePhoneNumberChange = (newPhoneNumber) => {
        setPhoneNumber(newPhoneNumber); // Update state when value changes
      };


      const formatDate = (date) => {
        const options = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true, // Ensures AM/PM format
        };
      
        return new Intl.DateTimeFormat("en-GB", options).format(date).replace(",", "");
      };

      // Handle form submission
      const handleSubmit = () => {



        if(openingKM<closingKM){

          setGenerateBill(true);
        
        const formData = {
          customerName,
          phoneNumber,
          pickupLocation,
          carModel:carModal.title,
          dropLocation,
          pickupDateTime,
          returnDateTime,
          tourDestination,
          numberOfDays,
          rentPerDay,
          extraCharge,
          openingKM,
          closingKM,
          receivedAmount,
          tollCharge,
          rentPerKM,
          totalKM,
          driverFee,
          modeOfPayment:modeOfPayment.title,
          driverName,
        };


      
        
        formData.billGeneratedDate = formatDate(new Date());

        setForm(formData);

 
      //  generatePDf(formData);
        // Submit or process the form data here (e.g., API call)
      }
else{
  showAlert("opening km is more then closing km change it","error");
}

      };


      
  async function generatePDf(formData) {

    
    setDisableButton(true);
 
      //  setLoading(true);
        // Wait for the API call to complete
        const response = await pdfDownload(formData);

        // Handle the response here
        if (response) {
           setDisableButton(false);
        } 
}
    // Handle change in trip type selection


    return (
        <Container sx={{marginBottom:10,marginTop:3}} >
                          <Helmet>
    <meta charset="UTF-8" />
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 <meta property="og:type" content="website" />
 <meta property="og:site_name" content="SVR Taxi Service | Call to book 9965821750" />
 <meta charset="UTF-8" />
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 <meta name="description" content="Reliable, taxi, service, in Salem, and, across India. Available 24/7 with professional drivers and affordable pricing. Book now for a comfortable journey."/>
 <meta name="keywords" content="best cab service in salem ,Salem to Yercaud Taxi Service - Affordable Rides to the Scenic Hill Station,Salem to Tirupati Taxi - Comfortable Rides to the Sacred Temple Town, Salem to Bangalore Taxi Service - Fast and Reliable City Transfers,Salem to Madurai Taxi Service - Explore the Historic City with Ease,Salem to Coimbatore Taxi Service - Quick and Safe Transportation,
Salem to Ooty Taxi Service - Scenic Rides to the Queen of Hill Stations, Salem to Kodaikanal Taxi Service - Travel to the Princess of Hill Stations , Salem to Kanyakumari Taxi Service - Journey to the Southern Tip of India , Salem to Chennai Taxi Service - Efficient Transfers to Tamil Nadu’s Capital , Salem to Oganakkal Falls Taxi Service - Explore the Stunning Waterfalls , Salem to Mettur Dam Taxi Service - Comfortable Rides to the Historic Dam , Salem to Thanjavur Taxi Service - Explore the Cultural Capital of Tamil Nadu ,taxi ,service, Salem, India, airport, transfers, intercity, travel, taxi ,booking,svr taxi,Affordable, taxi ,service ,from ,Salem, to ,Chennai,Best, outstation, cab ,service, from ,Salem ,to ,Kodaikanal,Taxi ,service ,for ,day, trips, in ,and, around, Salem,One-way ,taxi ,service ,from ,Salem ,to ,Bangalore,Book ,a, cab, for ,Salem to ,Tiruchirappalli ,trip,Salem to ,Yercaud ,cab ,service for ,family ,trips,Reliable ,24-hour, taxi, service in Salem,Taxi booking, for airport transfers, in Salem,Safe, taxi, service ,for solo ,women, travelers ,in Salem,Outstation, cab, services ,from Salem ,for business ,trips,Affordable car ,rental ,for Salem, sightseeing,Affordable ,Salem to ,Ooty, weekend, tour ,packages,Salem to ,Munnar, taxi, service with sightseeing packages,Pilgrimage, taxi service from, Salem to ,Samayapuram, Temple,
    Budget ,taxi, packages, from Salem to ,Hogenakkal, Falls,Cab service for Salem to ,Kodaikanal, honeymoon, package,Luxury, taxi service, for ,corporate ,trips, from Salem to ,Chennai,Round-trip, taxi ,service ,from Salem to, Mysore,Car, rental, with, driver, for ,outstation trips, in ,Tamil Nadu,Customized, tour packages, with taxi service in Tamil Nadu,
    Cheap, cab ,service for ,outstation trips, from Salem, best, taxi service in salem , best , taxi , service , Best taxi service in salem , Best Cab service in salem, contact us 9965821750 to book ride"/>
 <meta name="author" content="SVR Taxi" />
 <link rel="canonical" href="https://svrtaxi.netlify.app/billGeneration" />
{/* {    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" type="image/x-icon" /> } */}

 <meta property="og:title" content="Book the ride with in 1 minute | Salem non-stoppable taxi service" />
 <meta property="og:description" content="Providing safe, reliable, and affordable taxi services in Salem and across India. Book now for a hassle-free experience."/>
 
 <meta property="og:url" content="https://yourwebsite.com"/>
 <link rel="stylesheet" href="%PUBLIC_URL%/styles.css"/>
 <link rel="preconnect" href="https://fonts.googleapis.com"/>
 <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
 <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
 </Helmet>
              
              <Typography variant="h4" sx={{marginRight:20,backgroundColor:'black',width:'78%',color:'white'}}
              >
        Generate The Bill
      </Typography>
      <Card sx={{ mt: 3, backgroundColor: '#fff', maxWidth: 900 ,display:'flex',justifyContent:'center'}}>
              <CardContent >
              <Grid container spacing={2}>
 {/* Common fields for all trip types */}
 <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Customer Name"
              margin="normal"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{marginTop:2}}>
        <PhoneNumberField
          value={phoneNumber}
          onChange = {setPhoneNumber}
          
        /></Grid>
         <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Pickup Location"
          margin="normal"
          value={pickupLocation}
          onChange={(e) => setPickupLocation(e.target.value)}
        />
        </Grid>
        <Grid item xs={12} md={6} sx={{marginTop:2}}>
        <Autocomplete
          label={"Select Car Model"}
          lookupName={"carModel"}
          value={carModal}
          onChange={setCarModal} // Assuming Autocomplete returns a value
        />
        </Grid>
        <Grid item xs={12} md={6}>
      <TextField
              fullWidth
              label="Drop Location"
              margin="normal"
              value={dropLocation}
              onChange={(e) => setDropLocation(e.target.value)}
            /></Grid>
             <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Pickup Date and Time"
              type="datetime-local"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={pickupDateTime}
              onChange={(e) => setPickupDateTime(e.target.value)}
            /></Grid>
              <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Return Date and Time"
              type="datetime-local"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={returnDateTime}
              onChange={(e) => setReturnDateTime(e.target.value)}
            /></Grid>
 <Grid item xs={12} md={6}>
<TextField
              fullWidth
              label="Number of Days"
              type="number"
              margin="normal"
              value={numberOfDays}
              onChange={(e) => setNumberOfDays(e.target.value)}
            /></Grid>
            <Grid item xs={12} md={6} sx={{marginTop:2}}>
<AmountInput
              label="Rent Per Day"
              value={rentPerDay}
              onChange={setRentPerDay}
            /></Grid>
                <Grid item xs={12} md={6}>
            <DecimalInput
                label="Opening KiloMeter"
                value={openingKM}
                onChange={setOpeningKM}
              /></Grid>
               <Grid item xs={12} md={6}>
            <DecimalInput
                label="Closing KiloMeter"
                value={closingKM}
                onChange={setClosingKM}
              /></Grid>
            <Grid item xs={12} md={6} sx={{marginTop:2}}>
            <AmountInput
                label="Rent Per KiloMeter"
                value={rentPerKM}
                onChange={setRentPerKM}
              /></Grid>
            <Grid item xs={12} md={6}>
            <DecimalInput
                label="Total Kilo Meter"
                value={closingKM - openingKM}
                disable={true}
                onChange={setTotalKM}
                
              /></Grid>
            <Grid item xs={12} md={6} sx={{marginTop:2}}>
            <AmountInput
                label="Driver Fee"
                value={driverFee}
                onChange={setDriverFee}
              /></Grid>
            <Grid item xs={12} md={6} sx={{marginTop:2}}>
            <AmountInput
                label="Toll Charge"
                value={tollCharge}
                onChange={setTollCharge}
              /></Grid>
        
                <Grid item xs={12} md={6} sx={{marginTop:2}}>
            <AmountInput
                label="Received Amount"
                value={receivedAmount}
                onChange={setReceivedAmount}
              /></Grid>

<Grid item xs={12} md={6} sx={{marginTop:2}}>
<Autocomplete
          label={"Select Payment Mode"}
          lookupName={"paymentMode"}
          value={modeOfPayment}
          onChange={setModeOfPayment} // Assuming Autocomplete returns a value
        />
        </Grid>

                <Grid item xs={12} md={6}  sx={{marginTop:2}}>
            <AmountInput
                label="Extra Charge"
                value={extraCharge}
                onChange={setExtraCharge}
              /></Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            disabled={disableButton}
            onClick={handleSubmit}  // Handle form submission
          >
            Generate 
          </Button> </Box>
        
</CardContent></Card>
      {/* ToggleButtonGroup for selecting trip type */}
     
     { // generateBill && (

    //  <Modal heading={"Welcome to SVR Taxi"} action={false}>
      <PdfDownloadComponent ref={pdfDownloadRef} rideBookingDTO={form} billGeneratedDate={new Date()}/>
      //</Container>    </Modal>
   
   //  )
    }
    </Container>
    )

}



export default BillGeneration;